import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {Card, Switch, Input, Row, Col, Spin} from 'antd'

import { changeWebhookUrlRequest } from 'redux/Ekko/actions'

class SettingsWebhook extends React.Component {
    constructor(props) {
        super(props)

        const { webhook_url } = this.props.currentApplication

        this.state = {
            url_input: webhook_url,
            toogleSwitchWebhook: webhook_url ? true : false
        }
    }

    initState = webhook_url => {
        this.setState({
            url_input: webhook_url,
            toogleSwitchWebhook: webhook_url ? true : false
        })
    }

    updateWebhookUrl = url => {
        const { changeWebhookUrl } = this.props
        changeWebhookUrl({ url })
    }

    componentWillReceiveProps(nextProps) {
        const { webhook_url } = nextProps.currentApplication
        this.initState(webhook_url)
    }

    onSave = () => {
        this.updateWebhookUrl(this.state.url_input)
    }

    onSwitchChange = () => {
        this.setState(prevState => {
            const newstate = { toogleSwitchWebhook: !prevState.toogleSwitchWebhook }

            if (newstate.toogleSwitchWebhook === false) {
                this.updateWebhookUrl(null)
            }
            return newstate
        })
    }

    handleNameChange = event => {
        this.setState({ name: event.target.value })
    }

    onUrlChange = event => {
        this.setState({
            url_input: event.target.value
        })
    }

    render() {
        return (
            <Card title="Settings">
                <Spin spinning={this.props.loadingCurrentApp} delay={100}>
                    <Row type="flex" justify="space-between" align="middle">
                        <h2>WebHooks</h2>
                        <Switch checked={this.state.toogleSwitchWebhook} onChange={this.onSwitchChange} />
                    </Row>
                    <Row>
                        <Col sm={18} xs={24}>
                            <p>
                                Click the toggle button and enter the URL on your web server to accept webhooks. For more
                                information. see the Webhooks Guide.
                            </p>
                        </Col>
                    </Row>
                    {this.state.toogleSwitchWebhook ? (
                        <Input.Search
                            placeholder="Url must start with http:// or https://"
                            enterButton="Save"
                            onSearch={this.onSave}
                            defaultValue={this.state.url_input}
                            onChange={this.onUrlChange}
                        />
                    ) : null}
                </Spin>
            </Card>
        )
    }
}

const mapStateToProps = ({ ekko }) => ({
    currentApplication: ekko.currentApp,
    loadingCurrentApp: ekko.loadingCurrentApp
})

const mapActionsToProps = dispatch => ({
    changeWebhookUrl: bindActionCreators(changeWebhookUrlRequest, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(SettingsWebhook)
